import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	OnDestroy,
} from '@angular/core';
import { RemovedFiltersInfoService } from './removed-filters-info.service';
import { CloseModalSvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-removed-filters-info',
	imports: [CloseModalSvgComponent],
	templateUrl: './removed-filters-info.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemovedFiltersInfoComponent implements OnDestroy {
	private _removedFiltersInfoSrv = inject(RemovedFiltersInfoService);

	filters = this._removedFiltersInfoSrv.getRemovedFilters();

	showBothFiltersInfo = computed(
		() => this.filters().includes('degree') && this.filters().includes('mode'),
	);
	showDegreeFilterInfo = computed(
		() => this.filters().includes('degree') && !this.filters().includes('mode'),
	);
	showModeFilterInfo = computed(
		() => !this.filters().includes('degree') && this.filters().includes('mode'),
	);

	resetFilters() {
		this._removedFiltersInfoSrv.resetRemovedFilters();
	}

	ngOnDestroy(): void {
		this.resetFilters();
	}
}
